import React, { useRef } from "react";
import { useDatePickerState } from "react-stately";
import { useDatePicker, I18nProvider } from "react-aria";
import { FieldButton } from "./Button";
import { Calendar } from "./Calendar";
import { DateField, StyledField } from "./DateField";
import { Popover } from "./Popover";
import { Dialog } from "./Dialog";
import styled from "styled-components";
// Import the calendar icon as a URL instead of a component
import calendarIconUrl from "../../assets/icons/calendar.svg";

import { today, now, getLocalTimeZone } from "@internationalized/date";

export function DatePicker({
  label = "date",
  minValue = today(getLocalTimeZone()),
  defaultValue = now(getLocalTimeZone()),
  locale = "en-US",
  closeOnSelect = true,
  ...props
}) {
  const state = useDatePickerState({
    ...props,
    minValue,
    shouldCloseOnSelect: closeOnSelect,
  });
  const ref = useRef();
  const { groupProps, fieldProps, buttonProps, dialogProps, calendarProps } =
    useDatePicker({ ...props, minValue }, state, ref);
  return (
    <I18nProvider locale={locale}>
      <Container>
        <InputGroup {...groupProps} {...props} ref={ref}>
          <StyledField>
            <DateField {...fieldProps} granularity="day" />
            {/* {state.validationState === "invalid" && <div>⛔</div>} */}
          </StyledField>
          <FieldButton {...buttonProps} isPressed={state.isOpen}>
            <StyledIcon src={calendarIconUrl} alt="calendar" />
          </FieldButton>
        </InputGroup>
        {state.isOpen && (
          <Popover triggerRef={ref} state={state} placement="bottom start">
            <Dialog {...dialogProps}>
              <Calendar {...calendarProps} aria-label="Appointment date" />
            </Dialog>
          </Popover>
        )}
      </Container>
    </I18nProvider>
  );
}

const Container = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

const InputGroup = styled.div`
  width: auto;
  display: inline-flex;
  cursor: pointer;
  direction: ltr;
`;

const StyledIcon = styled.img`
  cursor: pointer;
  border: transparent;
  height: 1em;
  width: 1em;
  padding-bottom: 0.1em;
  :hover {
    opacity: 0.8;
  }
`;
